import { i18n } from '@lingui/core';
import type { Result } from '@schibsted-nmp/search-frontend-clients/suggest';
import React from 'react';
import { trackResultClick } from '../suggest/tracking';
import { ResultGroup } from './ResultGroup';
import { ResultOption } from './ResultOption';
import {
    SelectAction,
    type ActionFunction,
    type ResultsProps,
} from './ResultTypes';

const SHOW_SAVED_SEARCHES_RESULT = {
    resultType: 'SAVEDSEARCH',
} as Result;

export const savedSearchResultsAction: ActionFunction = ({
    config,
    metaData,
    result,
}) => {
    if (result === SHOW_SAVED_SEARCHES_RESULT) {
        const { siteUrl } = config;
        const savedSearchUrl = new URL(`${siteUrl}/savedsearches`);
        window.location.href = savedSearchUrl.href;
    } else {
        trackResultClick(result, metaData.tracking);
        window.location.href = result.url;
    }
    return SelectAction.CLOSE;
};

export function SavedSearchResults(props: ResultsProps) {
    const { headingClass, resultGroup } = props;

    const resultId = React.useId();

    const showSavedSearchesOption = (
        <ResultOption className="mt-4" result={SHOW_SAVED_SEARCHES_RESULT}>
            {() => (
                <a className="text-xs font-bold">
                    {i18n.t({
                        id: 'results.savedsearch.link',
                        message: 'Show all saved searches',
                    })}
                </a>
            )}
        </ResultOption>
    );

    return (
        <ResultGroup
            heading={resultGroup.groupingHeader}
            headingClass={headingClass}
        >
            <div className="grid md:grid-cols-2 gap-2 -mx-8">
                {resultGroup.results.map((result) => {
                    const imageSrc = getImageSrc(result);

                    return (
                        <ResultOption
                            key={`${result.resultType}-${result.order}-${resultId}`}
                            result={result}
                        >
                            {({ active, ariaLabel }) => (
                                <a
                                    aria-label={ariaLabel}
                                    className={`grid grid-rows-2 grid-cols-2 gap-x-8 p-8 s-text rounded-8 border ${
                                        active
                                            ? 's-border s-bg-hover'
                                            : 'border-transparent'
                                    }`}
                                    style={{
                                        gridTemplateColumns: 'min-content 1fr',
                                    }}
                                >
                                    <img
                                        className="row-span-2 max-w-min"
                                        src={imageSrc}
                                        width="40"
                                        height="40"
                                    />
                                    <span className="text-s overflow-hidden overflow-ellipsis whitespace-nowrap">
                                        {result.title}
                                    </span>
                                    <span className="text-xs s-text-subtle">
                                        {result.secondaryTitle}
                                    </span>
                                </a>
                            )}
                        </ResultOption>
                    );
                })}
            </div>
            {showSavedSearchesOption}
        </ResultGroup>
    );
}

function getImageSrc(result: Result) {
    const image = result.imageId ? result.imageId : 'finn';
    return `https://static.finncdn.no/_c/static/search-assets/newfrontier/${image}.png`;
}
